import * as Yup from 'yup'

import { BUDGET, NAME } from '../../../fields'
import { rightNameValidation } from '../../../validation'

export const validationSchema = Yup.object({
  [NAME]: rightNameValidation,
  [BUDGET]: Yup.string().required('Please enter budget')
})
